export default __webpack_public_path__ + "static/media/Sotrudnik_bg.6a6aff22.jpg";